export const NotificationEnum = {
  LIST: '/notifications',
  COUNT_UNREAD: '/notifications/count-unread',
  MARK_AS_READ: '/notifications/{notificationId}/read',
  MARK_ALL_AS_READ: '/notifications/mark-all-as-read',
  DELETE_ONE: '/notifications/{notificationId}',
  DELETE_ALL_READ: '/notifications/read',
}
